import axios from 'axios'
import moment from 'moment'
import apiConfiguration from '../utilities/api/apiConfiguration'

export const MODIFY_PRE_CHECK_IN_BEGIN = 'MODIFY_PRE_CHECK_IN_BEGIN'
export const MODIFY_PRE_CHECK_IN_SUCCESS = 'MODIFY_PRE_CHECK_IN_SUCCESS'
export const MODIFY_PRE_CHECK_IN_ERROR = 'MODIFY_PRE_CHECK_IN_ERROR'

export const modifyPreCheckInBegin = ({
	type: MODIFY_PRE_CHECK_IN_BEGIN
})

export const modifyPreCheckInSuccess = confirmation => ({
	type: MODIFY_PRE_CHECK_IN_SUCCESS,
	payload: confirmation
})

export const modifyPreCheckInError = error => ({
	type: MODIFY_PRE_CHECK_IN_ERROR,
	payload: { error }
})

export default function modifyPreCheckIn() {
	return (dispatch, getState) => {
		const configData = getState().configData.configuration
		const preCheckTimeData = getState().preCheckTimeData
		const reservations = getState().reservationData.confirmation
		const urlData = getState().availabilityData.urlData

		let currentClientId = null
		let currentHotelProvider = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			currentClientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		if (urlData.hotelProvider) {
			currentHotelProvider = urlData.hotelProvider
		}

		const urlParams = {
			clientId: currentClientId,
			hotelProvider: currentHotelProvider,
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === 'undefined') continue
			fetchQuery.append(key, urlParams[key])
		}

		let reservationEntries = {
			modifyParameters: []
		}

		// Window.session data for guests / pets
		let flowGuestData = null

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		for (let reservationKey in reservations) {
			let chainCode = null

			if (
				configData.hotel.options.properties &&
				urlData.hotelCode
			) {
				const matchedProperty = configData.hotel.options.properties.find(function(property) {
					return property.hotelCode === String(urlData.hotelCode)
				})

				if (matchedProperty) {
					chainCode = matchedProperty.chainCode
				}
			}

			let adultsVal = 1
			let childrenVal = 0

			// Set by session OR query with fallback
			if (
				flowGuestData &&
				flowGuestData[reservationKey] &&
				flowGuestData[reservationKey].adults >= 0
			) {
				adultsVal = flowGuestData[reservationKey].adults
			} else if (urlData.adults) {
				adultsVal = urlData.adults
			}

			// Set by session OR query with fallback
			if (
				flowGuestData &&
				flowGuestData[reservationKey] &&
				flowGuestData[reservationKey].children >= 0
			) {
				childrenVal = flowGuestData[reservationKey].children
			} else if (urlData.children) {
				childrenVal = urlData.children
			}

			let guestCounts = reservations[reservationKey].roomStays[0].guestCounts

			// Set adults
			for (let guestKey in guestCounts) {
				if (guestCounts[guestKey].ageQualifyingCode === 10) continue
				adultsVal = guestCounts[guestKey].count
			}

			// Set children
			for (let guestKey in guestCounts) {
				if (guestCounts[guestKey].ageQualifyingCode === 8) continue
				childrenVal = guestCounts[guestKey].count
			}

			let guestGivenName = ''
			let guestSurName = ''
			let guestPhone = ''
			let guestEmail = ''

			if (
				reservations[reservationKey].resGuests &&
				reservations[reservationKey].resGuests.profiles &&
				reservations[reservationKey].resGuests.profiles[0] &&
				reservations[reservationKey].resGuests.profiles[0].profile
			) {
				const guestProfile = reservations[reservationKey].resGuests.profiles[0].profile

				if (guestProfile.customer) {
					if (guestProfile.customer.personName) {
						const currentGuestNames = guestProfile.customer.personName

						if (
							currentGuestNames.givenName &&
							currentGuestNames.givenName !== ''
						) {
							guestGivenName = currentGuestNames.givenName
						}

						if (
							currentGuestNames.surName &&
							currentGuestNames.surName !== ''
						) {
							guestSurName = currentGuestNames.surName
						}
					}

					if (guestProfile.customer.telephone) {
						guestPhone = guestProfile.customer.telephone
					}

					if (guestProfile.customer.email) {
						guestEmail = guestProfile.customer.email
					}
				}
			}

			let iataCode = ''

			if (reservations[reservationKey].iataId) {
				iataCode = reservations.hotelReservations[reservationKey].iataId
			}

			let comment = ''

			for (let timeKey in preCheckTimeData) {
				// Render comment based on existing content or new additions
				if (
					reservations[reservationKey].resGlobalInfo.comments &&
					reservations[reservationKey].resGlobalInfo.comments[0] &&
					reservations[reservationKey].resGlobalInfo.comments[0].text
				) {
					comment = moment().format('dddd, MMMM Do YYYY, h:mm:ss a') + ' - PreCheckIn: true; PreCheckInTime: ' + moment(preCheckTimeData[timeKey], 'HH:mm').format('hh:mm a')  + '; ' + reservations[reservationKey].resGlobalInfo.comments[0].text
				} else {
					comment = moment().format('dddd, MMMM Do YYYY, h:mm:ss a') + ' - PreCheckIn: true; PreCheckInTime: ' + moment(preCheckTimeData[timeKey], 'HH:mm').format('hh:mm a') + ';'
				}
			}

			let reservationEntry = {
				roomStays: {
					crsConfirmNumber: reservations[reservationKey].uniqueId.id,
					hotelCode: reservations[reservationKey].roomStays[0].basicPropertyInfo.hotelCode,
					chainCode: chainCode,
					dateStart: reservations[reservationKey].roomStays[0].timeSpan.start,
					dateEnd: reservations[reservationKey].roomStays[0].timeSpan.end,
					ratePlanCode: reservations[reservationKey].roomStays[0].ratePlans[0].ratePlanCode,
					adults: adultsVal,
					children: childrenVal,
					roomTypes: {
						roomTypeCode: reservations[reservationKey].roomStays[0].roomTypes[0].roomTypeCode,
						numberOfUnits: 1
					}
				},
				resGuests: {
					givenName: guestGivenName,
					surName: guestSurName,
					telephone: guestPhone,
					email: guestEmail,
					primary: true,
				},
				comments: comment,
				services: reservations[reservationKey].services,
				iataId: iataCode
			}

			// Append activeRooms to reservationEntries
			reservationEntries['modifyParameters'].push(reservationEntry)
		}

		// Begin modify reservation set loading true & error false
		dispatch(modifyPreCheckInBegin)

		// Base API path
		let apiBase = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/reservation/' + reservations[0].id + '/modify?' + fetchQuery.toString()

		// Modify reservation request
		axios.put(apiBase + reservations['@id'], JSON.stringify(reservationEntries), apiConfiguration())
		.then((response) => {
			dispatch(modifyPreCheckInSuccess(response.data))
		})
		.catch(error => dispatch(modifyPreCheckInError(error)))
	}
}



// WEBPACK FOOTER //
// ./src/actions/modifyPreCheckInActions.js